import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';

import { storage } from '../utils/firebase';

export default class FileUploadApi {
  public static async uploadFile(file: File, path: string) {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  }

  public static async deleteFile(path: string) {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
  }

  public static async getUrlFromPath(path: string) {
    const storageRef = ref(storage, path);
    return await getDownloadURL(storageRef);
  }

  public static getNameFromPath(path: string) {
    const storageRef = ref(storage, path);
    return storageRef.name;
  }
}
